const events = {
    // v3
    formEvent: 'form',
    interactionFormEvent: 'interaction_form',
    interactionQuestionEvent: 'interaction_question',
    interactionQuestionMultipleChoiceEvent: 'interaction_question_multiple_choice',
    answerEvent: 'answer',
    metaEvent: 'meta',
    buttonEvent: 'button',

    // FB
    facebookPageViewEvent: 'facebookPageView',

    // v4
    campaignLoad: 'Funnel Loaded',
    pageLoad: 'Page Viewed',
    buttonClick: 'Button Clicked',
    cookiesAccept: 'Cookies Accepted',
    answerClick: 'Answer Clicked',
    formSubmit: 'Form Submitted',
    convert: 'Session Converted',
    campaignComplete: 'Funnel Completed',
    campaignClose: 'Funnel Closed',
    calendlyBook: 'Calendly Booked',
};

export default events;
